var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "investment-advisor"
  }, [_c("section", {
    staticClass: "investment-advisor__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "人工投顾",
      description: "互联网投顾平台功能包括直播、观点、问股、服务包、组合等，它引入智能选股、诊股以及机器人助手等智能工具，帮助投顾快速提升服务效率和质量，\n      运用互联网的方式吸引粉丝关注并转化创收。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "investment-advisor__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "investment-advisor__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "investment-advisor__cases-wrapper"
  }, [_c("Cases")], 1), _c("section", {
    staticClass: "investment-advisor__appointment-wrapper"
  }, [_c("Appointment2", {
    attrs: {
      productId: _vm.productId
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };